import React, { createContext, useContext, useState, useEffect } from "react";
import { t as tr } from "@/lib/i18n";

const LangCtx = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(localStorage.getItem("x1k_lang") || "fr");

  const setLang = (l) => {
    localStorage.setItem("x1k_lang", l);
    setLangState(l);
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => tr(key, lang);
  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
